export default __webpack_public_path__ + "static/media/linkedin.a1443ab6.png";